import { render, staticRenderFns } from "./adminTable.vue?vue&type=template&id=2cdb27a6&scoped=true"
import script from "./adminTable.vue?vue&type=script&lang=js"
export * from "./adminTable.vue?vue&type=script&lang=js"
import style0 from "./adminTable.vue?vue&type=style&index=0&id=2cdb27a6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cdb27a6",
  null
  
)

export default component.exports